module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gxpjE"))).then(() => parcelRequire('1iHdE'));